import { createAction } from '@reduxjs/toolkit';
import { UserDecisionConflictResolution } from './model';

export const resolutionCompleted = createAction<
  { newValue: UserDecisionConflictResolution },
  'creativeHub/uploader/resolutionCompleted'
>('creativeHub/uploader/resolutionCompleted');
export const resolutionInitiated = createAction<
  { filename: string },
  'creativeHub/uploader/resolutionInitiated'
>('creativeHub/uploader/resolutionInitiated');
export const contextReset = createAction<void, 'creativeHub/uploader/contextReset'>(
  'creativeHub/uploader/contextReset',
);
